import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountLimits } from 'app/account/account.model';

@Injectable({
  providedIn: 'root'
})
export class LimitsService {
  constructor(private http: HttpClient) {}

  public fetchLimits(): Observable<AccountLimits> {
    return this.http.get<AccountLimits>('/account/limits');
  }
}
